import React, { useEffect, useState } from 'react'
import AnalyticsChartCreator from './AnalyticsChartCreator'
import { Box } from '../../designSystem'
import { ErrorText } from './style'

const Overview = ({
  showRevenue,
  dailyRevenue,
  dailyRevenueShare,
  dailyActiveReads,
  bookSelected,
  isSeries = false
}) => {
  const [bookDailyReads, updateBookDailyReads] = useState(null)
  const [bookRevenue, updateBookRevenue] = useState(null)
  const [bookRevenueShare, updateBookRevenueShare] = useState(null)
  useEffect(() => {
    if (dailyActiveReads.length > 0) {
      updateBookDailyReads({
        labels: dailyActiveReads.map((data) => data.date).reverse(),
        datasets: [
          {
            label: `Daily Active ${isSeries ? 'Listeners' : 'Users'} %`,
            data: dailyActiveReads
              ?.map((data) => Number(data.value.toFixed(2)))
              .reverse(),
            fill: false,
            backgroundColor: 'rgba(125,197,245,0.67)',
            borderColor: '#2196f3',
            tension: 0.2,
          },
        ],
      })
    }
    if (showRevenue) {
      if (dailyRevenue.length > 0) {
        updateBookRevenue({
          labels: dailyRevenue.map((data) => data.date),
          datasets: [
            {
              label: 'Daily Revenue ₹',
              data: dailyRevenue?.map((data) => Number(data.value.toFixed(2))),
              fill: false,
              backgroundColor: 'rgba(125,197,245,0.67)',
              borderColor: '#2196f3',
              tension: 0.2,
            },
          ],
        })
      }
      if (dailyRevenueShare.length > 0) {
        updateBookRevenueShare({
          labels: dailyRevenueShare.map((data) => data.date),
          datasets: [
            {
              label: 'Daily Revenue Share ₹',
              data: dailyRevenueShare?.map((data) =>
                Number(data.value.toFixed(2))
              ),
              fill: false,
              backgroundColor: 'rgba(125,197,245,0.67)',
              borderColor: '#2196f3',
              tension: 0.2,
            },
          ],
        })
      }
    }
  }, [dailyActiveReads, dailyRevenue, dailyRevenueShare])

  const isMobile = window.screen.width < 600

  if (
    (!bookDailyReads && !showRevenue) ||
    (!bookDailyReads && showRevenue && !bookRevenue && !bookRevenueShare)
  ) {
    return (
      <Box my="8px">
        <ErrorText>
          Data of this category not found, please try again later
        </ErrorText>
      </Box>
    )
  }

  return (
    <>
      {isSeries && (
        <AnalyticsChartCreator
          isMobile={isMobile}
          chartData={bookDailyReads}
          chartTitle="Daily Active Listeners %"
          ToastTxt="No. of Valid listener who listened in the selected period / Total Valid  listeners who heard the series"
          tab="analytics_overview"
          bookSelected={bookSelected}
          module="dailyactivelisteners_infoicon"
        />
      )}
      {!isSeries && bookDailyReads && (
        <AnalyticsChartCreator
          isMobile={isMobile}
          chartData={bookDailyReads}
          chartTitle="Daily Active Readers %"
          ToastTxt="Percentage of valid readers who read the book in respective period / total valid readers who read the novel"
          tab="analytics_overview"
          bookSelected={bookSelected}
          module="dailyactivereaders_infoicon"
        />
      )}
      {!isSeries && showRevenue && (
        <>
          {bookRevenue && (
            <Box mt={10}>
              <AnalyticsChartCreator
                isMobile={isMobile}
                chartData={bookRevenue}
                chartTitle="Daily Revenue ₹"
                ToastTxt="This Graph shows the “Revenue” earned by the novel in the given day "
                tab="analytics_overview"
                bookSelected={bookSelected}
                module="dailyrevenue_infoicon"
              />
            </Box>
          )}
          {bookRevenueShare && (
            <Box mt={10}>
              <AnalyticsChartCreator
                isMobile={isMobile}
                chartData={bookRevenueShare}
                chartTitle="Daily Revenue Share ₹"
                ToastTxt="This Graph shows the “Revenue Share” earned by the novel in the given day "
                tab="analytics_overview"
                bookSelected={bookSelected}
                module="dailyrevenueshare_infoicon"
              />
            </Box>
          )}
        </>
      )}
    </>
  )
}

export default Overview
